var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g({class:_vm.$style.input,attrs:{"type":_vm.type},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('update', $event.target.value)}}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }